export default "__VITE_ASSET__CGgpe6Ba__"